import { AsEnumerable as Enumerable } from 'linq-es5';
import { ISiteConfigService } from '../../../core/';
import { IAuthService } from '../services/authorization';
import { IToastMessageService } from '../../../services';

let AuthInterceptorFactory: Function = function AuthenticationInterceptor($rootRouter: ng.Router,
    $q: ng.IQService,
    $window: ng.IWindowService,
    $location: ng.ILocationService,
    $injector: ng.auto.IInjectorService) {

    return {
        // Add authorization token to headers
        request: function (httpConfig) {

            httpConfig.headers = httpConfig.headers || {};
            var configSvc = $injector.get("SiteConfig") as ISiteConfigService;
            var auth = $injector.get("Auth") as IAuthService;
            return configSvc.getConfigAsync()
                .then((config) => {
                    return auth.getTokenForUrlAsync(httpConfig.url)
                        .then((result) => {
                            if (result.token) {
                                httpConfig.headers.Authorization = 'Bearer ' + result.token;
                                return $q.resolve(httpConfig);
                            }
                            else if (!result.tokenRequired) {
                                return $q.resolve(httpConfig);
                            }
                            else {
                                httpConfig.timeout = $q.resolve(httpConfig);
                                return httpConfig.timeout;
                            }
                        });
                });
        },

        // Intercept 401s and redirect you to login
        responseError: function (response) {
          
            let configSvc = $injector.get("SiteConfig") as ISiteConfigService;
            var toastMessageFactory = $injector.get("toastMessageFactory") as IToastMessageService;
            var auth = $injector.get("Auth") as IAuthService;
            return configSvc.getConfigAsync()
                .then( (config) => {
                    var currentRoute = $window.location.hash.toLowerCase();

                    var publicRoutes = Enumerable(config.publicRoutes);
                    //status is of -1 occurs when the request fails before it leaves 
                    //the browser, malformed header usual case, e.g.missing auth token for example.
                    if (response.status === 401 || response.status === -1) {
                        var auth = $injector.get("Auth") as IAuthService;
                        auth.clearTokens();
                        if (!publicRoutes.Any( (x) => { return currentRoute.startsWith(x); })) {
                            console.log('AsmController redirecting to SignIn - response.status: ' + response.status);
                            $rootRouter.navigate(['SignIn']);
                        }
                        else {
                            this.$location.reload();
                        }
                                               
                        return $q.reject(response);
                    }
                    else {

                        if (response && response.data && response.data.modelState) {
                            toastMessageFactory.modelStateErrors(response.data.modelState);
                        }
                        else if (response.status >= 500 && response.status <= 599) {
                            toastMessageFactory.showServerError();
                        }

                        return $q.reject(response);
                    }

                });
        }
    };
}

let Interceptor = {
    name: "authInterceptor",
    factory: ['$rootRouter', '$q', '$window', '$location', '$injector', AuthInterceptorFactory]
};

export default Interceptor;
export { Interceptor }




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/services/interceptor.ts